((BestSellersTabs, $) => {   

  const bindUIActions = () => {

    $(document).ready(function () {
      $('.js-best-seller-tab-title-container:first-child').addClass('is-active-title');
      $('.js-home-best-sellers-tab-content-container:nth-child(1)').show();  
      $('.js-home-best-sellers-tab-content-container:nth-child(2)').hide();
      $('.js-home-best-sellers-tab-content-container:nth-child(3)').hide();
    });

    $('.js-home-best-sellers-main-tab-container').find('.js-best-seller-tab-title-container:nth-child(1)').on('click', function () {
      $(this).addClass('is-active-title');
      if($(this).hasClass('is-active-title')) {
        $('.js-home-best-sellers-tab-content-container:nth-child(1)').show();
        $('.js-best-seller-tab-title-container:nth-child(2)').removeClass('is-active-title');
        $('.js-best-seller-tab-title-container:nth-child(3)').removeClass('is-active-title');
        $('.js-home-best-sellers-tab-content-container:nth-child(2)').hide();
        $('.js-home-best-sellers-tab-content-container:nth-child(3)').hide();
        $('.js-home-best-sellers-tab-tiles-container').slick('setPosition'); 
      };
    });

    $('.js-home-best-sellers-main-tab-container').find('.js-best-seller-tab-title-container:nth-child(2)').on('click', function () {
      $(this).toggleClass('is-active-title');
      if($(this).hasClass('is-active-title')) {
        $('.js-home-best-sellers-tab-content-container:nth-child(2)').show();
        $('.js-best-seller-tab-title-container:nth-child(1)').removeClass('is-active-title');
        $('.js-best-seller-tab-title-container:nth-child(3)').removeClass('is-active-title');
        $('.js-home-best-sellers-tab-content-container:nth-child(1)').hide();
        $('.js-home-best-sellers-tab-content-container:nth-child(3)').hide();
        $('.js-home-best-sellers-tab-tiles-container').slick('setPosition');
      };
    });

    $('.js-home-best-sellers-main-tab-container').find('.js-best-seller-tab-title-container:nth-child(3)').on('click', function () {
      $(this).toggleClass('is-active-title');
      if($(this).hasClass('is-active-title')) {
        $('.js-home-best-sellers-tab-content-container:nth-child(3)').show();
        $('.js-best-seller-tab-title-container:nth-child(1)').removeClass('is-active-title');
        $('.js-best-seller-tab-title-container:nth-child(2)').removeClass('is-active-title');
        $('.js-home-best-sellers-tab-content-container:nth-child(1)').hide();
        $('.js-home-best-sellers-tab-content-container:nth-child(2)').hide();
        $('.js-home-best-sellers-tab-tiles-container').slick('setPosition');
      };
    });
  };
  
  BestSellersTabs.init = () => {  
    bindUIActions();
  };

})(window.BestSellersTabs = window.BestSellersTabs || {}, jQuery);

